import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-24">
        <div className="flex max-w-xl flex-col items-center text-center">
          <span className="font-heading text-[7rem] font-black leading-none text-background-300 md:text-[9rem]">
            404
          </span>
          <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            这个页面没有找到
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            链接可能已经更新，或者这个事件解读暂时还没有发布。你可以回到首页，或者直接进入深度解读库搜索关键词。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              返回首页
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
            <Link
              to="/analysis"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              进入深度解读库
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}